import React from 'react';
import clsx from 'clsx';
import {composeClasses, styled, WithClasses} from '@netx/core-components/Theme';
import {
	settingsPaneRowClasses,
	getSettingsPaneRowUtilityClass,
	SettingsPaneRowClasses,
	SETTINGS_PANE_ROW_CLASS_NAME,
} from './settingsPaneRowClasses';

type SettingsPaneRowOwnerState = WithClasses<SettingsPaneRowClasses>;

const useUtilityClasses = (ownerState: SettingsPaneRowOwnerState) => {
	const {classes} = ownerState;

	const slots = {
		root: ['root'],
	};

	return composeClasses(slots, getSettingsPaneRowUtilityClass, classes);
};

const SettingsPaneRowRoot = styled('div', {
	name: SETTINGS_PANE_ROW_CLASS_NAME,
	slot: 'Root',
})(({theme}) => ({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'nowrap',
	width: '100%',
	flex: '0 0 auto',
	[`& + &`]: {
		borderTop: `1px solid ${theme.palette.custom.border}`,
	},
	[theme.breakpoints.down('sm')]: {
		borderTop: 0,
		flexDirection: 'column',
		'& > div': {
			width: '100%',
		},
	},
}));

export interface SettingsPaneRowProps
	extends React.DetailedHTMLProps<
			React.HTMLAttributes<HTMLDivElement>,
			HTMLDivElement
		>,
		WithClasses<SettingsPaneRowClasses, React.PropsWithChildren<{}>> {}

export const SettingsPaneRowPrimitive = ({
	classes: _classes,
	className,
	...props
}: SettingsPaneRowProps) => {
	const ownerState: SettingsPaneRowOwnerState = {
		classes: _classes,
		className,
	};

	const classes = useUtilityClasses(ownerState);

	return (
		<SettingsPaneRowRoot className={clsx(classes.root, className)} {...props} />
	);
};

export const SettingsPaneRow = SettingsPaneRowPrimitive;

export default SettingsPaneRow;
